import React, { useState, useEffect, useRef, useCallback } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import { openDB } from 'idb';

import './index.css';
import CosmicBackground from './components/CosmicBackground';
import ProductCard from './components/ProductCard';
import TrackingLine from './components/TrackingLine';
import Navbar from './components/Navbar';
import ProductDetail from './components/ProductDetail';
import { fetchProductsLocal } from './api/client';

const regionOptions = [
  { value: 'US', label: '🇺🇸 USA' }, { value: 'CA', label: '🇨🇦 Canada' }, { value: 'MX', label: '🇲🇽 Mexico' }, { value: 'BR', label: '🇧🇷 Brazil' },
  { value: 'AR', label: '🇦🇷 Argentina' }, { value: 'CL', label: '🇨🇱 Chile' }, { value: 'CO', label: '🇨🇴 Colombia' }, { value: 'PE', label: '🇵🇪 Peru' },
  { value: 'BO', label: '🇧🇴 Bolivia' }, { value: 'CR', label: '🇨🇷 Costa Rica' }, { value: 'EC', label: '🇪🇨 Ecuador' }, { value: 'GT', label: '🇬🇹 Guatemala' },
  { value: 'HN', label: '🇭🇳 Honduras' }, { value: 'NI', label: '🇳🇮 Nicaragua' }, { value: 'PA', label: '🇵🇦 Panama' }, { value: 'PY', label: '🇵🇾 Paraguay' },
  { value: 'SV', label: '🇸🇻 El Salvador' }, { value: 'UY', label: '🇺🇾 Uruguay' },
  { value: 'GB', label: '🇬🇧 UK' }, { value: 'FR', label: '🇫🇷 France' }, { value: 'DE', label: '🇩🇪 Germany' }, { value: 'IT', label: '🇮🇹 Italy' },
  { value: 'ES', label: '🇪🇸 Spain' }, { value: 'PT', label: '🇵🇹 Portugal' }, { value: 'IE', label: '🇮🇪 Ireland' }, { value: 'NL', label: '🇳🇱 Netherlands' },
  { value: 'BE', label: '🇧🇪 Belgium' }, { value: 'AT', label: '🇦🇹 Austria' }, { value: 'CH', label: '🇨🇭 Switzerland' }, { value: 'SE', label: '🇸🇪 Sweden' },
  { value: 'NO', label: '🇳🇴 Norway' }, { value: 'DK', label: '🇩🇰 Denmark' }, { value: 'FI', label: '🇫🇮 Finland' }, { value: 'PL', label: '🇵🇱 Poland' },
  { value: 'RU', label: '🇷🇺 Russia' }, { value: 'UA', label: '🇺🇦 Ukraine' }, { value: 'TR', label: '🇹🇷 Turkey' }, { value: 'MT', label: '🇲🇹 Malta' },
  { value: 'LU', label: '🇱🇺 Luxembourg' },
  { value: 'SA', label: '🇸🇦 Saudi Arabia' }, { value: 'AE', label: '🇦🇪 UAE' }, { value: 'KW', label: '🇰🇼 Kuwait' }, { value: 'QA', label: '🇶🇦 Qatar' },
  { value: 'BH', label: '🇧🇭 Bahrain' }, { value: 'OM', label: '🇴🇲 Oman' }, { value: 'LB', label: '🇱🇧 Lebanon' },
  { value: 'ZA', label: '🇿🇦 South Africa' }, { value: 'IN', label: '🇮🇳 India' },
  { value: 'JP', label: '🇯🇵 Japan' }, { value: 'HK', label: '🇭🇰 Hong Kong' }, { value: 'KR', label: '🇰🇷 Korea' }, { value: 'TW', label: '🇹🇼 Taiwan' },
  { value: 'SG', label: '🇸🇬 Singapore' }, { value: 'MY', label: '🇲🇾 Malaysia' },
  { value: 'AU', label: '🇦🇺 Australia' }, { value: 'NZ', label: '🇳🇿 New Zealand' }
];

const platformOptions = [
  { value: 'PS5', label: 'PlayStation 5' }, { value: 'PS4', label: 'PlayStation 4' },
  { value: 'PS3', label: 'PlayStation 3' }, { value: 'PS_Vita', label: 'PS Vita' }, { value: 'PSP', label: 'PSP' }
];

const dbPromise = openDB('psna-state', 1, {
  upgrade(db) { db.createObjectStore('state'); },
});

const Footer = () => (
  <footer className="site-footer">
    <div className="footer-emperor-text">
        <h2 className="emperor-text title-sub"></h2>
        <div className="emperor-header-container">
            <h1 className="emperor-text title-main">The  Immortal  Emperor The Manipulator of Humans</h1>
            <h2 className="emperor-text title-sub">The  Emperor  of  Kings</h2>
            <h3 className="emperor-text title-desc">The one and The only Vampire</h3>
        </div>
    </div>
    
    <div className="social-links">
      <a href="https://discord.com/users/1200161324869623870" target="_blank" rel="noreferrer" className="social-icon" title="Discord User">
        <svg viewBox="0 0 24 24"><path d="M20.317 4.37a19.791 19.791 0 0 0-4.885-1.515.074.074 0 0 0-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 0 0-5.487 0 12.64 12.64 0 0 0-.617-1.25.077.077 0 0 0-.079-.037A19.736 19.736 0 0 0 3.677 4.37a.07.07 0 0 0-.032.027C.533 9.046-.32 13.58.099 18.057a.082.082 0 0 0 .031.057 19.9 19.9 0 0 0 5.993 3.03.078.078 0 0 0 .084-.028 14.09 14.09 0 0 0 1.226-1.994.076.076 0 0 0-.041-.106 13.107 13.107 0 0 1-1.872-.892.077.077 0 0 1-.008-.128 10.2 10.2 0 0 0 .372-.292.074.074 0 0 1 .077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 0 1 .078.01c.12.098.246.198.373.292a.077.077 0 0 1-.006.127 12.299 12.299 0 0 1-1.873.892.077.077 0 0 0-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 0 0 .084.028 19.839 19.839 0 0 0 6.002-3.03.077.077 0 0 0 .032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 0 0-.031-.03zM8.02 15.33c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.956-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.956 2.418-2.157 2.418zm7.975 0c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.955-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.946 2.418-2.157 2.418z"/></svg>
      </a>
      <a href="https://discord.gg/psna" target="_blank" rel="noreferrer" className="social-icon" title="Discord Server">
        <svg viewBox="0 0 24 24"><path d="M20.317 4.37a19.791 19.791 0 0 0-4.885-1.515.074.074 0 0 0-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 0 0-5.487 0 12.64 12.64 0 0 0-.617-1.25.077.077 0 0 0-.079-.037A19.736 19.736 0 0 0 3.677 4.37a.07.07 0 0 0-.032.027C.533 9.046-.32 13.58.099 18.057a.082.082 0 0 0 .031.057 19.9 19.9 0 0 0 5.993 3.03.078.078 0 0 0 .084-.028 14.09 14.09 0 0 0 1.226-1.994.076.076 0 0 0-.041-.106 13.107 13.107 0 0 1-1.872-.892.077.077 0 0 1-.008-.128 10.2 10.2 0 0 0 .372-.292.074.074 0 0 1 .077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 0 1 .078.01c.12.098.246.198.373.292a.077.077 0 0 1-.006.127 12.299 12.299 0 0 1-1.873.892.077.077 0 0 0-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 0 0 .084.028 19.839 19.839 0 0 0 6.002-3.03.077.077 0 0 0 .032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 0 0-.031-.03z"/></svg>
      </a>
      <a href="https://github.com/lI-Isekai-Il" target="_blank" rel="noreferrer" className="social-icon" title="GitHub">
        <svg viewBox="0 0 24 24"><path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z"/></svg>
      </a>
      <a href="https://twitter.com/lI_Iseaki_Il" target="_blank" rel="noreferrer" className="social-icon" title="Twitter">
        <svg viewBox="0 0 24 24"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>
      </a>
      <a href="https://instagram.com/li_seaki_il" target="_blank" rel="noreferrer" className="social-icon" title="Instagram">
        <svg viewBox="0 0 24 24"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/></svg>
      </a>
      <a href="https://t.me/lI_Iseaki_Il" target="_blank" rel="noreferrer" className="social-icon" title="Telegram">
        <svg viewBox="0 0 24 24"><path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 11.944 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z"/></svg>
      </a>
    </div>

    <div className="footer-links">
                                                                                                        | 
      <a href="https://policies.google.com/privacy" target="_blank" rel="noreferrer">PRIVACY POLICY</a> | 
      <a href="https://policies.google.com/terms" target="_blank" rel="noreferrer">TERMS OF SERVICE</a> | 
    
    </div>

    <div className="copyright">
      &copy; 2026 THE IMMORTAL EMPEROR ARCHIVES.
      Developed by lI-Isekai-Il | lI_Isekai_Il The Immortal Emperor The Manipulator of Humans The Emperor of Kings The one and The only Vampire , with x22 help.                                                             
      We are not affiliated, associated, authorized, endorsed by or in any way officially connected to Sony Interactive Entertainment Inc.                                                 
      All titles, content, publisher names, trademarks, artwork, and associated imagery are trademarks and/or copyright material of their respective owners. All rights reserved.                                                      
      All data that is fetched is coming from public sources making it not fall under disclosing private information as any individual can reach this data with the right steps of research.                               
      This site is protected by reCAPTCHA and the Google Privacy Policy and Terms of Service apply.
    </div>
  </footer>
);

const App = () => {
  const [region, setRegion] = useState('ALL');
  const [platform, setPlatform] = useState('ALL');
  const [type, setType] = useState('avatars');
  const [search, setSearch] = useState('');
  const [freeOnly, setFreeOnly] = useState(false);
  const [products, setProducts] = useState([]);
  const [page, setPage] = useState(1);
  const [isLoading, setIsLoading] = useState(true);
  const scrollRef = useRef(null);

  const handleHomeReset = () => {
    setRegion('ALL');
    setPlatform('ALL');
    setType('avatars');
    setSearch('');
    setFreeOnly(false);
    setPage(1);
  };

  useEffect(() => {
    const loadState = async () => {
      try {
        const db = await dbPromise;
        const saved = await db.get('state', 'lastState');
        if (saved) {
          setRegion(saved.region || 'ALL'); setPlatform(saved.platform || 'ALL');
          setType(saved.type || 'avatars'); setPage(saved.page || 1);
        }
      } catch (e) { console.warn(e); }
    };
    loadState();
  }, []);

  useEffect(() => {
    const saveState = async () => {
      const db = await dbPromise;
      await db.put('state', { region, platform, type, page }, 'lastState');
    };
    saveState();
  }, [region, platform, type, page]);

  const fetchProducts = useCallback(async () => {
    setIsLoading(true);
    let allData = [];
    const regionsToFetch = region === 'ALL' ? ['US', 'GB', 'JP', 'SA', 'HK', 'AE'] : [region];
    const platformsToFetch = platform === 'ALL' ? ['PS5', 'PS4', 'PS3', 'PS_Vita', 'PSP'] : [platform];

    for (const r of regionsToFetch) {
      for (const p of platformsToFetch) {
        const data = await fetchProductsLocal({ region: r, platform: p });
        allData = [...allData, ...data];
      }
    }
    
    if (region === 'ALL' || platform === 'ALL') allData.sort(() => Math.random() - 0.5);
    setProducts(allData);
    setIsLoading(false);
  }, [region, platform]);

  useEffect(() => { fetchProducts(); }, [fetchProducts]);

 // --- FILTER LOGIC ---
  const filteredTotal = products.filter(p => {
    // 1. Search Logic
    if (search) {
      const lower = search.toLowerCase();
      if (!p.name?.toLowerCase().includes(lower) && !p.sku?.toLowerCase().includes(lower)) {
        return false;
      }
    }


    if (freeOnly) {
      const price = p.price ? p.price.toLowerCase() : '';
      const freeKeywords = [
        'free', 'gratuit', 'gratis', 'gratuito', 'kostenlos', 'бесплатно',
        'bezpłatne', 'ücretsiz', 'مجاني', 'ilmainen', 'ingyenes', 'zdarma',
        'δωρεάν', '無料', '免費', '免费', '무료', '0,00', '0.00'
      ];
      const isFree = freeKeywords.some(k => price.includes(k)) || 
                     price === '¥0' || price === 'kr 0' || price === '£0.00' || price === '$0.00';
      
      if (!isFree) return false;
    }

    return true;
  });

  const ITEMS_PER_PAGE = 50;
  const displayedProducts = filteredTotal.slice(
    (page - 1) * ITEMS_PER_PAGE,
    (page - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
  );

  const staggeredProducts = displayedProducts.map((p, i) => ({
    ...p,
    style: { marginTop: i % 2 !== 0 ? '120px' : '0px' }
  }));

  return (
    <Router>
      <CosmicBackground />
      <Navbar 
        onSearch={setSearch} region={region} setRegion={setRegion} regionOptions={regionOptions}
        platform={platform} setPlatform={setPlatform} platformOptions={platformOptions}
        type={type} setType={setType}
        freeOnly={freeOnly} setFreeOnly={setFreeOnly}
        onHomeReset={handleHomeReset} 
      />

      <div className="app" ref={scrollRef}>
        <Switch>
          <Route exact path="/">
            
            <div className="emperor-header-container">
               <div className="logo-container" style={{marginBottom: '20px'}}>
                  <img src={process.env.PUBLIC_URL + '/logo.png'} alt="Emperor Logo" className="hero-logo" style={{maxWidth: '150px', filter: 'drop-shadow(0 0 10px red)'}} />
               </div>
               
            <div className="emperor-header-container">
               <h1 className="emperor-text title-main">The  Immortal  Emperor</h1>
               <h2 className="emperor-text title-sub">The  Emperor  of  Kings</h2>
               <h3 className="emperor-text title-desc">The one and The only Vampire</h3>
            </div>
            </div>

            {/**/}
            <div className="filter-container">
                <button 
                    className={`glow-btn ${freeOnly ? 'active-filter' : ''}`} 
                    style={{padding:'10px 20px', fontSize:'0.9rem', borderColor: freeOnly ? 'var(--blood-red)' : '#333'}}
                    onClick={() => { setFreeOnly(!freeOnly); setPage(1); }}
                >
                    {freeOnly ? 'SHOW ALL' : 'SHOW FREE ONLY'}
                </button>
            </div>

            <div className="stats-bar-container">
               <div className="stats-glass-box">
                  <span>REGION: <span style={{color:'var(--primary-glow)'}}>{region}</span></span>
                  <span style={{margin: '0 15px', color: '#444'}}>|</span>
                  <span>ASSETS: <strong>{filteredTotal.length}</strong></span>
               </div>
            </div>

            <div className="grid-container-wrapper">
                <TrackingLine />
                <div className="product-grid">
                  <AnimatePresence>
                    {isLoading ? (
                       <div style={{gridColumn: '1/-1', textAlign: 'center', marginTop: '150px', color: '#00f3ff'}}>
                          <h2>LOADING DATABASE...</h2>
                       </div>
                    ) : staggeredProducts.length > 0 ? (
                      staggeredProducts.map((p) => (
                        <motion.div
                          key={p.id}
                          initial={{ opacity: 0, scale: 0.9 }} animate={{ opacity: 1, scale: 1 }} exit={{ opacity: 0, scale: 0.9 }} transition={{ duration: 0.3 }}
                          style={{ height: '100%' }}
                        >
                          <ProductCard product={p} style={p.style} />
                        </motion.div>
                      ))
                    ) : (
                      <div style={{gridColumn: '1/-1', textAlign: 'center', marginTop: '100px', color: '#666'}}>
                         <h2>NO DATA FOUND</h2>
                         <p>Try clearing filters</p>
                      </div>
                    )}
                  </AnimatePresence>
                </div>
            </div>
            
            <div className="pagination-container">
              <button className="glow-btn" onClick={() => setPage(p => Math.max(1, p - 1))} disabled={page === 1}> &lt; PREV </button>
              <div className="page-indicator">PAGE {page}</div>
              <button className="glow-btn" onClick={() => setPage(p => p + 1)}> NEXT &gt; </button>
            </div>
          </Route>

          <Route path="/product/:id">
             <ProductDetail allProducts={products} />
          </Route>
        </Switch>

        <Footer />
      </div>
    </Router>
  );
};

export default App;